import { useEffect, useRef, useState } from 'react';
import * as React from 'react';

type Props = Omit<React.HTMLProps<HTMLInputElement>, 'onChange'|'value'> & {
    value: string
    parse: (value:string) => string
    onChange?: (value:string) => void
}

export default function(props:Props) {
    const { value, onBlur, onChange, parse, ...otherProps } = props;
    const [tmpValue, setTmpValue] = useState(value);
    const inputRef = useRef<HTMLInputElement>();

    useEffect(() => {
        //Don't update when focused
        if(document && inputRef.current && inputRef.current === document.activeElement) {
            return;
        }

        setTmpValue(value);
    }, [value]);

    useEffect(() => {
        //Update only when focused
        if(document && inputRef.current && inputRef.current !== document.activeElement) {
            return;
        }

        const processedValue = parse(tmpValue);
        onChange && onChange(processedValue);
    }, [tmpValue]);

    return <input
        ref={inputRef}
        type="text"
        value={tmpValue}
        onChange={(e) => setTmpValue(e.target.value)}
        onBlur={(e) => {
            setTmpValue(value);
            onBlur && onBlur(e);
        }}
        {...otherProps}
    />
}